import EarlyBirdCorporateConnect from './EarlyBirdCorporateConnect';

export default EarlyBirdCorporateConnect;



// WEBPACK FOOTER //
// ./src/views/EarlyBirdCorporateConnect/index.js